export default {
    data(){
        return {
            sortColumnsList: [],
            sortColumnDirection: null
        }
    },
    mounted: function(){
        let sortColumnsList = this.$store.getters[this.namespace + '/getSortColumn'];

        if (sortColumnsList && sortColumnsList.length)
        {
            this.sortColumnsList = sortColumnsList;
        }
        else
        {
            let defaultOrderedColumns = this.$store.getters[this.namespace + "/getDefaultOrderedColumn"];
            if (defaultOrderedColumns && defaultOrderedColumns.length)
            {
                let sorting = {
                    'field': defaultOrderedColumns.field,
                    'direction': defaultOrderedColumns.defaultSortingOrder
                };

                this.sortColumnsList.push(sorting);
            }
        }
    },
    methods: {
        getSortableColumnIndex: function(column)
        {
            let key = this.sortColumnsList.findIndex(function(item){
                return (item.field == column.field)
            });

            if (key != -1)
            {
                return key;
            }
            else
            {
                return false;
            }
        },
        applySorting: function(column){
            let defaultSortOrder = column.defaultSortOrder ? column.defaultSortOrder : 'ASC';
            let reverseDefaultSortOrder = ( defaultSortOrder === 'ASC' ) ? 'DESC' : 'ASC';
            let sortColumnIndex = this.getSortableColumnIndex(column);

            if (this.sortColumnsList.length == 1 && sortColumnIndex !== false)
            {
                let element = this.sortColumnsList[sortColumnIndex];

                if (element.direction == defaultSortOrder)
                {
                    element.direction = reverseDefaultSortOrder;
                    this.$set(this.sortColumnsList, sortColumnIndex, element);
                }
                else if (element.direction == reverseDefaultSortOrder)
                {
                    this.sortColumnsList.splice(sortColumnIndex, 1);
                }
                else
                {
                    element.direction = defaultSortOrder;
                    this.$set(this.sortColumnsList, sortColumnIndex, element);
                }
            }
            else if (this.sortColumnsList.length)
            {
                this.sortColumnsList = [];

                let sorting = {
                    'field': column.field,
                    'direction': defaultSortOrder
                };

                this.sortColumnsList.push(sorting);
            }
            else
            {
                let sorting = {
                    'field': column.field,
                    'direction': defaultSortOrder
                };

                this.sortColumnsList.push(sorting);
            }

            this.$store.dispatch(this.namespace + '/setSorting', this.sortColumnsList);
            this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
            this.$store.dispatch(this.namespace + '/startLoading');
        },
        applyMultipleColumn: function(column){
            let defaultSortOrder = column.defaultSortOrder ? column.defaultSortOrder : 'ASC';
            let reverseDefaultSortOrder = ( defaultSortOrder === 'ASC' ) ? 'DESC' : 'ASC';

            if (column.sort)
            {
                let sortColumnIndex = this.getSortableColumnIndex(column);

                if (sortColumnIndex !== false)
                {
                    let element = this.sortColumnsList[sortColumnIndex];

                    if (element.direction == defaultSortOrder)
                    {
                        element.direction = reverseDefaultSortOrder;
                        this.$set(this.sortColumnsList, sortColumnIndex, element);
                    }
                    else if (element.direction == reverseDefaultSortOrder)
                    {
                        this.sortColumnsList.splice(sortColumnIndex, 1);
                    }
                    else
                    {
                        element.direction = defaultSortOrder;
                        this.$set(this.sortColumnsList, sortColumnIndex, element);
                    }

                    this.$store.dispatch(this.namespace + '/setSorting', this.sortColumnsList);
                    this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                    this.$store.dispatch(this.namespace + '/startLoading');
                }
                else
                {
                    let sorting = {
                        'field': column.field,
                        'direction': defaultSortOrder
                    };

                    this.sortColumnsList.push(sorting);

                    this.$store.dispatch(this.namespace + '/setSorting', this.sortColumnsList);
                    this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                    this.$store.dispatch(this.namespace + '/startLoading');
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/mixins/sortTableMixin.js